const state = {
  visible: false, // 显示分享弹窗

  url: null, // 海报url
  title: null, // 转发标题
  desc: null, // 转发简介
  link: null, // 转发链接
  imgUrl: null, // 转发缩略图
  moreOption: [],
  hideOption: [],
};

const mutations = {
  TOGGLE(state, flag) {
    state.visible = flag;
  },
  SET_DATA(state, data) {
    for (const key in data) {
      state[key] = data[key];
    }
  },
};

const actions = {
  // 显示分享弹窗
  show(
    { commit },
    data = { url, title, desc, link, imgUrl, moreOption, hideOption }
  ) {
    data.moreOption = data.moreOption || [];
    data.hideOption = data.hideOption || [];
    commit("SET_DATA", data);
    commit("TOGGLE", true);
  },
  // 隐藏分享弹窗
  hide({ commit }) {
    commit("TOGGLE", false);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
